﻿import { getRequiredElement } from "../Utilities/attributes";

const contentRating = document.querySelector<HTMLElement>("[data-content-rating]");

if (!contentRating) {
  throw "Content rating missing.";
}

contentRating.addEventListener("htmx:afterSettle", (event: Event) => {
  const target = event.target as HTMLElement;
  if (target.dataset.jsSectionName == "inputdislikereason") {
    const submitButton = getRequiredElement<HTMLInputElement>(
      contentRating,
      "#dislikereason",
      "Submit button not found."
    );

    const reasonCheckboxes = contentRating.querySelectorAll<HTMLInputElement>(
      "[data-js-feedback-templates]"
    );
    const somethingElse = getRequiredElement<HTMLInputElement>(
      contentRating,
      "[data-js-something-else]",
      "Something else template missing."
    );
    const commentTextArea = getRequiredElement<HTMLInputElement>(
      contentRating,
      "#comment",
      "Comment textarea missing."
    );

    reasonCheckboxes.forEach(checkbox => {
      checkbox.addEventListener("change", (event: Event) => {
        const target = event.target as HTMLInputElement;
        if (target.checked) {
          submitButton.disabled = false;
        }
      });
    });

    somethingElse.addEventListener("change", (event: Event) => {
      const target = event.target as HTMLInputElement;
      if (target.checked) {
        commentTextArea.disabled = false;
        commentTextArea.required = true;
        commentTextArea.focus();
      }
      else {
        commentTextArea.disabled = true;
        commentTextArea.required = false;
      }
    });
  }
});
